import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { label: "Mission", href: "#mission" },
  { label: "Actions", href: "#actions" },
  { label: "Impact", href: "#impact" },
  { label: "Adhésion", href: "#adhesion" },
  { label: "Don", href: "#don" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-background/70 border-b border-border/40 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <img src="/logo.png" alt="ONG HERITAGES" className="w-11 h-11 rounded-full object-cover ring-1 ring-border" />
          <span className="font-heading text-2xl font-semibold tracking-tight text-primary leading-none">
            ONG&nbsp;HERITAGES
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-foreground/70 hover:text-secondary transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <button
              data-testid="header-registre-btn"
              onClick={() => navigate("/registre")}
              className="px-5 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:-translate-y-0.5 transition-transform"
            >
              Le Registre Foncier
            </button>
          ) : (
            <>
              <Link
                to="/connexion"
                data-testid="header-login-btn"
                className="text-sm font-medium text-foreground/80 hover:text-secondary transition-colors"
              >
                Connexion
              </Link>
              <a
                href="#adhesion"
                data-testid="header-join-btn"
                className="px-5 py-2.5 rounded-full bg-secondary text-secondary-foreground text-sm font-medium hover:-translate-y-0.5 transition-transform"
              >
                Rejoindre
              </a>
            </>
          )}
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-foreground"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl backdrop-blur-xl bg-background/90 border border-border/50 p-6 flex flex-col gap-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
               className="text-base font-medium text-foreground/80">
              {l.label}
            </a>
          ))}
          <div className="h-px bg-border" />
          {user ? (
            <button onClick={() => navigate("/registre")} className="text-left font-medium text-secondary">
              Le Registre Foncier
            </button>
          ) : (
            <>
              <Link to="/connexion" className="font-medium text-foreground/80">Connexion</Link>
              <a href="#adhesion" onClick={() => setOpen(false)} className="font-medium text-secondary">Rejoindre</a>
            </>
          )}
        </div>
      )}
    </header>
  );
}
